import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import DownloadsList from "./views/DownloadsList";
import * as downloadsActions from "../../../redux/modules/downloads";
import * as optionsActions from "../../../redux/modules/options";

const mapStateToProps = state => {
  return {
    loading: state.downloads.loading,
    success: state.downloads.success,
    message: state.downloads.message,
    data: state.downloads.data,
    total: state.downloads.total,
    limit: state.downloads.limit,
    page: state.downloads.page,
    order: state.downloads.order,
    orderMode: state.downloads.orderMode,
    deleted: state.downloads.deleted,
    deletedId: state.downloads.deletedId,
    token: state.downloads.token,

    headerLoaded: state.options.headerLoaded,
    translate: state.options.translate,
    searchModel: state.options.searchModel,
    columns: state.options.columns,
    columnsOrder: state.options.columnsOrder
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getListHeader: optionsActions.getGridInfo,
      optionsReset: optionsActions.reset,

      getList: downloadsActions.downloadsList,
      delete: downloadsActions.downloadDelete,
      setLoading: downloadsActions.setLoading,
      reset: downloadsActions.reset
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadsList);



// WEBPACK FOOTER //
// ./src/Containers/Pages/Downloads/DownloadsList.js